import React, {FunctionComponent} from "react";
import "./LoadingGif.scss";
import {ReactComponent as LogoSmall} from "../../assets/logo-small.svg";
import LoadingBase, {LoadingGifProps} from "../LoadingBase/LoadingBase";


const LoadingGif: FunctionComponent<LoadingGifProps> = (loadingGifProps) => {
  const {
    errorText,
    passedInText,
    overrideLoadingText,
    fullScreen,
    style,
  } = loadingGifProps;

  return <LoadingBase loadingAsset={<LogoSmall id="loading-logo-id" className="loading-logo"/>}
                      errorText={errorText}
                      passedInText={passedInText}
                      overrideLoadingText={overrideLoadingText}
                      fullScreen={fullScreen}
                      style={style}/>
}

export default LoadingGif;
